<script>
    import { onMount } from 'svelte';
    import Endpoints from './Endpoints.svelte'
    import UnmanagedEndpoints from './UnmanagedEndpoints.svelte'
    import { currentPage } from '../store.js';
    import Tabs from '../components/Tabs.svelte';
    
    let activeTabValue = "Managed";
    let items = [{label: "Managed", value: "Managed"}, {label: "Unmanaged", value: "Unmanaged"}];

    onMount(async () => {     
        currentPage.set('endpoints');
    });
</script>

<h4 class="font-weight-bold text-primary mb-2">Endpoints</h4>  
<Tabs {items} bind:activeTabValue={activeTabValue}></Tabs>

{#if activeTabValue == "Managed"}
    <Endpoints></Endpoints>
{:else}
    <UnmanagedEndpoints byVessel={false}></UnmanagedEndpoints>
{/if}

<style>

</style>